import Drawer from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Drawer';
import React from 'react';
import PropTypes from 'prop-types';
import Container from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ScenarioDetailsPicker/components/Container';
import Header from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ScenarioDetailsPicker/components/Header';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = makeStyles(() => ({
  paper: {
    width: '100%',
  },
}));

const ScenarioDetailsDrawer = ({ open }) => {
  const classes = useStyles();
  return (
    <Drawer
      anchor="left"
      open={open}
      PaperProps={{ className: classes.paper }}
    >
      <Header />
      <Container />
    </Drawer>
  );
};

ScenarioDetailsDrawer.defaultProps = {
  open: false,
};

ScenarioDetailsDrawer.propTypes = {
  open: PropTypes.bool,
};

export default ScenarioDetailsDrawer;
